/* eslint-disable max-len */

import React from 'react';

export const CloudOfflineIcon = () => {
  return (
    <svg
      className="stroke-icon"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.6667 11.0533C13.5333 10.3867 14 9.33333 14 8.13333C14 6.4 12.8 4.93333 11.2 4.53333C10.9333 2.53333 9.2 1 7.13333 1C5.73333 1 4.53333 1.66667 3.8 2.73333"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4 4.66667C2.53333 5.2 1.33333 6.6 1.33333 8.26667C1.33333 10.4 3.06667 12.1333 5.2 12.1333H11.3333"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.33333 1.33333L14.6667 14.6667"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
